import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import polylabel from "polylabel";
import areapolygon from "area-polygon";
import { connect } from "react-redux";

const STYLE_TEXT = {
  textAnchor: "middle",
  fontFamily: '"Courier New", Courier, monospace',
  pointerEvents: "none",
  fontWeight: "bold",

  // http://stackoverflow.com/questions/826782/how-to-disable-text-selection-highlighting-using-css
  WebkitTouchCallout: "none" /* iOS Safari */,
  WebkitUserSelect: "none" /* Chrome/Safari/Opera */,
  MozUserSelect: "none" /* Firefox */,
  MsUserSelect: "none" /* Internet Explorer/Edge */,
  userSelect: "none",
};
const filterVerticesWithDuplication = (selectedAreaId, areas) => {
  const selectedVertices = areas.get(selectedAreaId).get("vertices");
  let filteredVertices = new Map();

  areas.forEach((area, areaId) => {
    if (areaId !== selectedAreaId) {
      const areaVertices = area.get("vertices");
      selectedVertices.forEach((vertex) => {
        if (areaVertices.includes(vertex)) {
          filteredVertices = filteredVertices.set(vertex, true);
        }
      });
    }
  });

  return selectedVertices
    .filter((vertex) => !filteredVertices.has(vertex))
    .toList();
};
const Area = function ({ layer, area, catalog, state }) {
  const [splitRoomName, setSplitRoomName] = useState([]);
  // console.log(area);
  // useEffect(() => {
  //   // Function to split roomName into substrings based on available width
  //   const splitRoomNameIntoArray = (roomName, availableWidth) => {
  //     const words = roomName.split(" ");
  //     const maxCharsPerLine = Math.floor(availableWidth / 12); // Assuming font-size of 12px per character
  //     let lines = [];
  //     let currentLine = "";

  //     words.forEach((word, index) => {
  //       if (currentLine.length === 0) {
  //         currentLine = word;
  //       } else {
  //         const potentialLine = currentLine + " " + word;
  //         if (potentialLine.length <= maxCharsPerLine) {
  //           currentLine = potentialLine;
  //         } else {
  //           lines.push(currentLine);
  //           currentLine = word;
  //         }
  //       }

  //       // Handle the last word separately
  //       if (index === words.length - 1) {
  //         lines.push(currentLine);
  //       }
  //     });
  //
  //     // Split lines longer than maxCharsPerLine into chunks
  //     let chunkedLines = [];
  //     lines.forEach(line => {
  //       if (line.length <= maxCharsPerLine) {
  //         chunkedLines.push(line);
  //       } else {
  //         let i = 0;
  //         while (i < line.length) {
  //           chunkedLines.push(line.slice(i, i + maxCharsPerLine));
  //           i += maxCharsPerLine;
  //         }
  //       }
  //     });

  //     return chunkedLines;
  //   };

  //   // Calculate available width for displaying the room name
  //   let polygon = area.vertices.toArray().map((vertexID) => {
  //     let { x, y } = layer.vertices.get(vertexID);
  //     return [x, y];
  //   });

  //   let polygonWithHoles = polygon;
  //   area.holes.forEach((holeID) => {
  //     let polygonHole = layer.areas
  //       .get(holeID)
  //       .vertices.toArray()
  //       .map((vertexID) => {
  //         let { x, y } = layer.vertices.get(vertexID);
  //         return [x / 100, y / 100];
  //       });

  //     polygonWithHoles = polygonWithHoles.concat(polygonHole.reverse());
  //   });

  //   let { width } = calculateBoundingBox(polygonWithHoles, 1);

  //   const availableWidth = width / 100; // Convert to meters if necessary
  //   const lines = splitRoomNameIntoArray(area.properties.get("roomName"), availableWidth);

  //   setSplitRoomName(lines);
  // }, [area, catalog, layer]);

  let rendered = catalog.getElement(area.type).render2D(area, layer,state );
  let { x: centeredX, y: centeredY } = getPolygonCentroid(rendered.props.d);
  let renderedAreaSize = null;

  let polygon = area.vertices.toArray().map((vertexID) => {
    let { x, y } = layer.vertices.get(vertexID);
    return [x, y];
  });
  let polygon2 = area.vertices.toArray().map((vertexID) => {
    let { x, y } = layer.vertices.get(vertexID);
    return { x, y };
  });

  // let polygon2 = filterVerticesWithDuplication(area.id, layer.areas)
  //   .toArray()
  //   .map((vertexID) => {
  //     let { x, y } = layer.vertices.get(vertexID);
  //     return { x, y };
  //   });

  let { x: centeredX1, y: centeredY1 } = getSafeLabelPosition(polygon2);
  console.log(centeredX1, centeredY1);
  let polygonWithHoles = polygon;
  area.holes.forEach((holeID) => {
    let polygonHole = layer.areas
      .get(holeID)
      .vertices.toArray()
      .map((vertexID) => {
        let { x, y } = layer.vertices.get(vertexID);
        return [x / 100, y / 100];
      });

    polygonWithHoles = polygonWithHoles.concat(polygonHole.reverse());
  });

  // const centerPoint = findPolygonCenter(polygonWithHoles);
  let areaSize = areapolygon(polygon, false);

  area.holes.forEach((areaID) => {
    let hole = layer.areas.get(areaID);
    let holePolygon = hole.vertices.toArray().map((vertexID) => {
      let { x, y } = layer.vertices.get(vertexID);
      return [x, y];
    });
    areaSize -= areapolygon(holePolygon, false);
  });
  let { width, height } = calculateBoundingBox(polygonWithHoles, 1);

  //

  useEffect(() => {
    // Function to split roomName into chunks of up to 8 characters each
    const splitRoomNameIntoChunks = (roomName) => {
      const maxCharsPerChunk = width / 20 <= 0 ? width / 20 : width / 20;
      const chunks = [];
      let startIndex = 0;

      while (startIndex < roomName.length) {
        const chunk = roomName.slice(startIndex, startIndex + maxCharsPerChunk);
        chunks.push(chunk);
        startIndex += maxCharsPerChunk;
      }

      return chunks;
    };
    const roomName = area.properties.get("roomName");
    const chunks = splitRoomNameIntoChunks(roomName);

    // Replace with your state handling logic
    setSplitRoomName(chunks);
  }, [area, width]);
  renderedAreaSize = (
    <Fragment>
      {splitRoomName.map((line, index) => (
        <text
          key={index}
          display={area.visible ? "block" : "none"}
          x="0"
          y={index === 0 ? 0 : -index * -20} // Adjust spacing between lines
          // transform={`translate(${centerPoint[0]} ${centerPoint[1]}) scale(1, -1)`}
          transform={`translate(${centeredX1} ${centeredY1 + 20}) scale(1, -1)`}
          style={{
            ...STYLE_TEXT,
            fontSize: `${
              12 / state.getIn(["react-planner"]).viewer2D.toJS().a < 12
                ? 12
                : 12 /
                  (state.getIn(["react-planner"]).viewer2D.toJS().a < 0.3
                    ? state.getIn(["react-planner"]).viewer2D.toJS().a * 1.5
                    : state.getIn(["react-planner"]).viewer2D.toJS().a)
            }px`,
            whiteSpace: "pre-line", // Allow text to break into multiple lines
            textAlign: "center", // Center-align text
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            fontWeight: 100,
          }}
        >
          {line}
        </text>
      ))}
      {state.getIn(["react-planner"]).dimension && (
        <text
          display={area.visible ? "block" : "none"}
          x="0"
          y={splitRoomName.length * 20}
          // transform={`translate(${centerPoint[0]} ${centerPoint[1]}) scale(1, -1)`}
          transform={`translate(${centeredX1} ${centeredY1}) scale(1, -1)`}
          style={{
            ...STYLE_TEXT,
            fontSize: `${
              12 / state.getIn(["react-planner"]).viewer2D.toJS().a < 12
                ? 12
                : 12 /
                  (state.getIn(["react-planner"]).viewer2D.toJS().a < 0.3
                    ? state.getIn(["react-planner"]).viewer2D.toJS().a * 1.5
                    : state.getIn(["react-planner"]).viewer2D.toJS().a)
            }px`,
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
          }}
        >
          {(width / 100).toFixed(2)}m x {(height / 100).toFixed(2)}m
        </text>
      )}
    </Fragment>
  );

  return (
    <g
      data-element-root
      data-prototype={area.prototype}
      data-id={area.id}
      data-selected={area.selected}
      data-layer={layer.id}
    >
      {rendered}
      {renderedAreaSize}
    </g>
  );
};

Area.propTypes = {
  area: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
};

function mapStateToProps(reduxState) {
  return {
    state: reduxState,
  };
}

export default connect(mapStateToProps)(Area);

function getPolygonCentroid(pathData) {
  // Split the SVG path data into individual commands
  var commands = pathData.split(/(?=[A-Z])/);

  // Initialize variables for centroid calculation
  var area = 0;
  var cx = 0;
  var cy = 0;

  // Iterate over the commands to calculate the centroid
  for (var i = 0; i < commands.length; i++) {
    var command = commands[i];
    var params = command.substring(1).trim().split(/[ ,]+/);

    // Extract the coordinates of the vertices
    var x = parseFloat(params[params.length - 2]);
    var y = parseFloat(params[params.length - 1]);

    // Calculate the area of the polygon using the shoelace formula
    var nextParams = commands[(i + 1) % commands.length]
      .substring(1)
      .trim()
      .split(/[ ,]+/);
    var nextX = parseFloat(nextParams[nextParams.length - 2]);
    var nextY = parseFloat(nextParams[nextParams.length - 1]);
    area += x * nextY - nextX * y;

    // Calculate the centroid using the centroid formula
    cx += (x + nextX) * (x * nextY - nextX * y);
    cy += (y + nextY) * (x * nextY - nextX * y);
  }

  // Divide by 6 times the polygon's area to get the centroid coordinates
  area /= 2;
  cx /= 6 * area;
  cy /= 6 * area;

  return { x: cx, y: cy };
}

function getPolygonCentroidByVertexPositions(vertices) {
  const n = vertices.length;

  if (n < 4) {
    throw new Error(
      "At least 4 vertices are required to perform this operation."
    );
  }

  // Calculate distances between every pair of vertices
  const distances = [];
  for (let i = 0; i < n; i++) {
    for (let j = i + 1; j < n; j++) {
      const distance = Math.sqrt(
        Math.pow(vertices[i].x - vertices[j].x, 2) +
          Math.pow(vertices[i].y - vertices[j].y, 2)
      );
      distances.push({ i, j, distance });
    }
  }

  // Sort distances by ascending order
  distances.sort((a, b) => a.distance - b.distance);

  // Select the closest four vertices
  const vertexSet = new Set();
  let k = 0;
  while (vertexSet.size < 4 && k < distances.length) {
    vertexSet.add(distances[k].i);
    vertexSet.add(distances[k].j);
    k++;
  }

  // Extract the selected four vertices
  const selectedVertices = Array.from(vertexSet).map(
    (index) => vertices[index]
  );

  // Calculate the centroid of the selected vertices
  let Cx = 0,
    Cy = 0;
  for (const vertex of selectedVertices) {
    Cx += vertex.x;
    Cy += vertex.y;
  }
  Cx /= selectedVertices.length;
  Cy /= selectedVertices.length;

  return {
    x: Cx,
    y: Cy,
  };
}

function getPolygonCentroidByFarthestVertices(vertices) {
  const n = vertices.length;

  if (n < 4) {
    throw new Error(
      "At least 4 vertices are required to perform this operation."
    );
  }

  // Calculate distances between every pair of vertices
  const distances = [];
  for (let i = 0; i < n; i++) {
    for (let j = i + 1; j < n; j++) {
      const distance = Math.sqrt(
        Math.pow(vertices[i].x - vertices[j].x, 2) +
          Math.pow(vertices[i].y - vertices[j].y, 2)
      );
      distances.push({ i, j, distance });
    }
  }

  // Sort distances by descending order to find the farthest pairs
  distances.sort((a, b) => b.distance - a.distance);

  // Select the farthest four vertices
  const vertexSet = new Set();
  let k = 0;
  while (vertexSet.size < 4 && k < distances.length) {
    vertexSet.add(distances[k].i);
    vertexSet.add(distances[k].j);
    k++;
  }

  // Extract the selected four vertices
  const selectedVertices = Array.from(vertexSet).map(
    (index) => vertices[index]
  );

  // Calculate the centroid of the selected vertices
  let Cx = 0,
    Cy = 0;
  for (const vertex of selectedVertices) {
    Cx += vertex.x;
    Cy += vertex.y;
  }
  Cx /= selectedVertices.length;
  Cy /= selectedVertices.length;

  return {
    x: Cx,
    y: Cy,
  };
}

function getPolygonCentroidByModerateVertices(vertices) {
  const n = vertices.length;

  if (n < 4) {
    throw new Error(
      "At least 4 vertices are required to perform this operation."
    );
  }

  // Calculate distances between every pair of vertices
  const distances = [];
  for (let i = 0; i < n; i++) {
    for (let j = i + 1; j < n; j++) {
      const distance = Math.sqrt(
        Math.pow(vertices[i].x - vertices[j].x, 2) +
          Math.pow(vertices[i].y - vertices[j].y, 2)
      );
      distances.push({ i, j, distance });
    }
  }

  // Sort distances by ascending order
  distances.sort((a, b) => a.distance - b.distance);

  // Find the median distance index
  const medianIndex = Math.floor(distances.length / 2);

  // Select vertices around the median distance
  const vertexSet = new Set();
  let k = medianIndex;
  while (vertexSet.size < 4 && k < distances.length) {
    vertexSet.add(distances[k].i);
    vertexSet.add(distances[k].j);
    k++;
  }

  // Ensure we have 4 vertices (backtrack if needed)
  k = medianIndex - 1;
  while (vertexSet.size < 4 && k >= 0) {
    vertexSet.add(distances[k].i);
    vertexSet.add(distances[k].j);
    k--;
  }

  // Extract the selected four vertices
  const selectedVertices = Array.from(vertexSet).map(
    (index) => vertices[index]
  );

  // Calculate the centroid of the selected vertices
  let Cx = 0,
    Cy = 0;
  for (const vertex of selectedVertices) {
    Cx += vertex.x;
    Cy += vertex.y;
  }
  Cx /= selectedVertices.length;
  Cy /= selectedVertices.length;

  return {
    x: Cx,
    y: Cy,
  };
}

// another solution
function getSafeLabelPosition(vertices) {
  // Calculate the total area of the polygon
  const totalArea = calculatePolygonArea(vertices);

  // Define the percentages to try
  const percentages = [40, 20, 10];

  // Try each percentage in decreasing order
  for (const percentage of percentages) {
    const minArea = (percentage / 100) * totalArea;

    const candidatePoints = generateCandidatePoints(vertices, 10); // Adjust step size as needed
    const validPoints = candidatePoints.filter((point) =>
      isPointInPolygon(point, vertices)
    );

    if (validPoints.length === 0) {
      continue; // No valid points found; try the next percentage
    }

    let bestPoint = null;
    let maxArea = -Infinity;

    for (const point of validPoints) {
      const area = calculateEmptyAreaAroundPoint(point, vertices);
      if (area >= minArea && area > maxArea) {
        maxArea = area;
        bestPoint = point;
      }
    }

    if (bestPoint) {
      return bestPoint;
    }
  }

  // If no suitable area was found with any percentage, return the centroid of the polygon
  return calculatePolygonCentroid(vertices);
}

function generateCandidatePoints(vertices, stepSize) {
  const bounds = getPolygonBounds(vertices);
  const points = [];

  for (let x = bounds.minX; x <= bounds.maxX; x += stepSize) {
    for (let y = bounds.minY; y <= bounds.maxY; y += stepSize) {
      points.push({ x, y });
    }
  }

  return points;
}

function calculatePolygonArea(vertices) {
  let area = 0;
  const n = vertices.length;

  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n;
    area += vertices[i].x * vertices[j].y;
    area -= vertices[j].x * vertices[i].y;
  }

  area = Math.abs(area) / 2;
  return area;
}

function calculateEmptyAreaAroundPoint(point, vertices) {
  // Placeholder function for empty area calculation
  // Implement actual logic if needed
  return Math.random() * 1000; // Replace with actual computation
}

function getPolygonBounds(vertices) {
  const minX = Math.min(...vertices.map((v) => v.x));
  const minY = Math.min(...vertices.map((v) => v.y));
  const maxX = Math.max(...vertices.map((v) => v.x));
  const maxY = Math.max(...vertices.map((v) => v.y));
  return { minX, minY, maxX, maxY };
}

function isPointInPolygon(point, vertices) {
  let inside = false;
  for (let i = 0, j = vertices.length - 1; i < vertices.length; j = i++) {
    const xi = vertices[i].x,
      yi = vertices[i].y;
    const xj = vertices[j].x,
      yj = vertices[j].y;

    const intersect =
      yi > point.y !== yj > point.y &&
      point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

function calculatePolygonCentroid(vertices) {
  let Cx = 0,
    Cy = 0;
  const n = vertices.length;
  let signedArea = 0;

  for (let i = 0; i < n; i++) {
    const x0 = vertices[i].x;
    const y0 = vertices[i].y;
    const x1 = vertices[(i + 1) % n].x;
    const y1 = vertices[(i + 1) % n].y;
    const a = x0 * y1 - x1 * y0;
    signedArea += a;
    Cx += (x0 + x1) * a;
    Cy += (y0 + y1) * a;
  }

  signedArea *= 0.5;
  Cx /= 6 * signedArea;
  Cy /= 6 * signedArea;

  return { x: Cx, y: Cy };
}

//

function findPolygonCenter(vertices) {
  // Initialize sum for x and y coordinates
  let sumX = 0;
  let sumY = 0;

  // Calculate sum of x and y coordinates
  for (let i = 0; i < vertices.length; i++) {
    sumX += vertices[i][0];
    sumY += vertices[i][1];
  }

  // Calculate average for x and y coordinates
  const centerX = sumX / vertices.length;
  const centerY = sumY / vertices.length;

  return [centerX, centerY];
}

function calculateBoundingBox(vertices, conversionFactor) {
  if (vertices.length === 0) {
    return { width: 0, height: 0 };
  }

  // Initialize min and max values with the coordinates of the first vertex
  let minX = vertices[0][0];
  let minY = vertices[0][1];
  let maxX = vertices[0][0];
  let maxY = vertices[0][1];

  // Iterate through the vertices to find the minimum and maximum coordinates
  for (let i = 1; i < vertices.length; i++) {
    const x = vertices[i][0];
    const y = vertices[i][1];

    minX = Math.min(minX, x);
    minY = Math.min(minY, y);
    maxX = Math.max(maxX, x);
    maxY = Math.max(maxY, y);
  }

  // Calculate width and height in meters
  const width = (maxX - minX) * conversionFactor;
  const height = (maxY - minY) * conversionFactor;

  return { width, height };
}
